<template>
    <keep-alive>
        <div v-if="this.success === true" class="alert alert-success alert-full" role="alert">
            {{ i18n.tvoje_subory_boli_uspesne_prijate_ako_si_uspel_sa_dozvies_v_mojich_vysledkoch_hned_ako_tvoje_odpovede_vyhodnotime }}
        </div>
        <div v-else>
            <div class="dz-more" ref="more">+</div>
            <div class="ListItem EditItem--clean">
                <h3 v-if="this.role">{{ i18n.krok }} 4 / 4</h3>
                <h3 v-else>{{ i18n.krok }} 3 / 3</h3>
            </div>
            <div class="FormWrap">
                <p>{{ i18n.prilozte_subory_na_hodnorenie_nahrajte_naraz_subory_tykajuce_sa_daneho_kola_sutaze_a_prislusnych_riesitelov }}</p>
                <br>
                <vue-dropzone ref="myVueDropzone"
                              id="dropzone"
                              :options="dropzoneOptions"
                              @vdropzone-sending="dzSending"
                              @vdropzone-success="dzSuccess"
                              @vdropzone-error="dzError"
                              @vdropzone-file-added='handleMoreThumbnail'
                              @vdropzone-removed-file='handleMoreThumbnail'
                ></vue-dropzone>
                <div class="InputField">
                    <p>{{ i18n.komentar }}:</p>
                    <textarea v-model="comment" rows="5" class=""></textarea>
                </div>
                <div v-if="this.success === false" class="alert alert-danger alert-full" role="alert">
                    {{ this.error_message }}
                </div>
                <div class="SubmitButton">
                    <button type="submit" class="button " @click="upload" v-if="!is_uploading">{{ i18n.odoslat_vysledky }}
                    </button>
                    <p v-else>{{ i18n.nahravame_tvoje_vysledky }}</p>
                </div>
            </div>
        </div>
    </keep-alive>
</template>

<script>

    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    export default {
        name: 'dropzone',
        props: ['taskId', 'role', 'url'],
        components: {
            vueDropzone: vue2Dropzone
        },
        data: function () {
            return {
                dropzoneOptions: {},
                comment: null,
                success: null,
                is_uploading: false,
                error_message: '',
                i18n: i18n
            }
        },
        mounted () {
            this.$el.removeChild(this.$refs.more)
        },
      created() {
          this.dropzoneOptions = {
            // url: '/akademia/profil/nahravanie-vysledkov/sutaze/ulohy/' + this.taskId + '/upload',
            url: this.url,
            headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            createImageThumbnails: false,
            autoProcessQueue: false,
            addRemoveLinks: true,
            uploadMultiple: true,
            acceptedFiles: '.jpg,.jpeg,.bmp,.png,.zip,.rar,.pdf,.doc,.docx,.ods,.ots,.odc,.odf,.ppt,.pptx,.mp3,.mp4,.mpeg,.3gp,.avi,.tif',
            dictDefaultMessage: this.i18n.vyberte_subory_potiahnutim_na_toto_miesto_alebo_kliknutim_sem,
            dictRemoveFile: this.i18n.odstranit,
            dictInvalidFileType: this.i18n.nepodporovany_typ_suboru,
            dictCancelUpload: this.i18n.zrusit_nahravanie,
            dictCancelUploadConfirmation: this.i18n.ste_si_isti,
            dictUploadCanceled: this.i18n.nahravanie_zrusene,
            parallelUploads: 30,
            timeout: 300000,
            withCredentials: true
          }
      },
      methods: {
            upload() {
                this.success = null;
                this.error_message = '';
                if (!this.is_uploading) {
                    var dropzone = this.$refs.myVueDropzone;
                    var count = dropzone.getQueuedFiles().length;

                    if (count) {
                        this.is_uploading = true;
                        dropzone.processQueue();
                    } else {
                        this.success = false;
                        this.error_message = this.i18n.najskor_vyberte_subory;
                        this.is_uploading = false
                    }
                }
            },
            dzSending(file, xhr, formData) {
                formData.append('comment', this.comment);
            },
            dzSuccess(file, response) {
                this.success = true;
                // history.pushState('', 'Zasaďte sa medzi nás | Strom života', response.url);
                this.is_uploading = false
            },
            dzError() {
                var dropzone = this.$refs.myVueDropzone;
                dropzone.removeAllFiles();
                this.comment = null;
                this.success = false;
                this.error_message = this.i18n.nebolo_mozne_nahrat_vysledky_ziakov;
                this.is_uploading = false
            },
            handleMoreThumbnail () {
                let dropzone = this.$refs.myVueDropzone.dropzone
                dropzone.files.length > 0
                    ? dropzone.element.appendChild(this.$refs.more)
                    : dropzone.element.removeChild(this.$refs.more)
            }
        }
    }
</script>

<style>
    .dz-more {
        display: block;
        margin-bottom: 16px;
        border: 2px dashed #CCDCE8;
        width: 100%;
        height: 100px;
        box-sizing: border-box;
        color: #CCDCE8;
        font-size: 60px;
        text-align: center;
        line-height: 100px;
        pointer-events: none;
    }
</style>
